import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  withComponentInputBinding,
  withViewTransitions,
} from '@angular/router';
import { provideHotToastConfig } from '@ngxpert/hot-toast';
import { AppInsightsService } from '@wz-app-insights';
import { TunnelSanteCoreModule } from '@wz-core';
import { CommonModels, ConfigurationModels } from '@wz-models';
import {
  AuthenticationServiceBase,
  BaseNavigationService,
  LoadingService,
  ResourcesService,
} from '@wz-services';
import { wzCoreInitializerFactory } from 'libs/modules/tunnelsante/wz-core/wz-core-initializers';
import {
  RESOURCE_TOKEN,
  WAZARIAPP_TOKEN,
} from 'libs/modules/tunnelsante/wz-core/wz-core-injection-tokens';
import { wzCoreMatTooltipDefaultOptions } from 'libs/modules/tunnelsante/wz-core/wz-core-material-exports';
import {
  wzCoreHttpInterceptorFactory,
  wzCoreMiscServices,
  wzCoreServices,
} from 'libs/modules/tunnelsante/wz-core/wz-core-providers';
import { provideNgxMask } from 'ngx-mask';
import { routes } from './app-tunnel.route';
import { appBrokerResources } from './resources/app-tunnel-resources';
import { AfiAuthenticationService } from './services/tunnel-authentication.service';
import { TunnelNavigationService } from './services/tunnel-navigation.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withViewTransitions(), withComponentInputBinding()),
    provideAnimations(),
    provideNgxMask(),
    LoadingService,
    ConfigurationModels.Configuration,
    AppInsightsService,
    TunnelNavigationService,
    AfiAuthenticationService,
    TunnelNavigationService,

    provideHttpClient(
      // optionnellement, tu ajoutes tes intercepteurs ici
      withInterceptorsFromDi(),
    ),

    provideNativeDateAdapter(),
    importProvidersFrom(TunnelSanteCoreModule),
    { provide: WAZARIAPP_TOKEN, useValue: CommonModels.TunnelSanteAppEnum },
    provideHotToastConfig({
      duration: 8000, // 8 secondes (la popup peut aussi être fermée avec la croix)
      autoClose: true,
      stacking: 'depth',
      position: 'top-right',
    }),

    wzCoreHttpInterceptorFactory,
    ...wzCoreMiscServices,
    ...wzCoreServices,
    wzCoreInitializerFactory,
    {
      provide: AuthenticationServiceBase,
      useExisting: AfiAuthenticationService,
    },
    { provide: BaseNavigationService, useExisting: TunnelNavigationService },
    ResourcesService,
    { provide: RESOURCE_TOKEN, useValue: appBrokerResources },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: wzCoreMatTooltipDefaultOptions,
    },
  ],
};
